var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudCheckWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 10.6693H4.10467C2.39 10.6666 1 9.32859 1 7.67792C1 6.02792 2.39 4.68992 4.10467 4.68992C4.36667 3.51526 5.30067 2.55659 6.55467 2.17459C7.808 1.79326 9.192 2.04592 10.184 2.84126C11.176 3.63459 11.6253 4.84592 11.364 6.02059H12.024C12.944 6.02059 13.7373 6.56126 14.1093 7.34459",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0666,
    cy: 10.9334,
    r: 2.8,
    fill: "#59D875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1624 10.8988L11.5569 11.2933L12.6965 10.1536C12.8466 10.0035 13.0933 10.0155 13.2281 10.1794C13.3456 10.3222 13.3355 10.5309 13.2047 10.6617L11.8489 12.0175C11.6897 12.1767 11.4299 12.1711 11.2778 12.0051L10.6838 11.3571C10.5639 11.2263 10.5683 11.0243 10.6937 10.8988C10.8232 10.7694 11.033 10.7694 11.1624 10.8988Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckWhite);
export default __webpack_public_path__ + "static/media/cloud-check-white.b6bc61132192bc8fcfaa54dcae403ff5.svg";
export { ForwardRef as ReactComponent };